<header class="global-header">
  <i2g-link
    [href]="invoice2goUrl"
    [icon]="invoice2goLogo"
    [openInNewTab]="true"
    [trackingObject]="trackingObject"
    [trackingAction]="logoTrackingAction"
    class="invoice2go-logo"
  >
  </i2g-link>

  <div class="action-wrapper">
    <span *ngIf="label" class="label">
      {{ label }}
    </span>

    <i2g-link
      *ngIf="externalUrl; else internalRoute"
      [href]="externalUrl"
      [label]="route?.label"
      class="external-url"
    >
    </i2g-link>

    <ng-template #internalRoute>
      <i2g-router-link
        *ngIf="route"
        class="internal-route"
        e2eId="internal-route"
        buttonStyle="default"
        [route]="route.route"
        [label]="route.label"
        [navigationExtras]="route.navigationExtras"
        [alignment]="AlignmentEnum.center"
        [trackingObject]="trackingObject"
        [trackingAction]="route.trackingAction"
      >
      </i2g-router-link>
    </ng-template>
  </div>
</header>
